module.exports = __webpack_public_path__ + "img/fastforward.a9656afb.png";